<div class="boxed collections">
  <div class="sticky">
    <div class="margin-b-1">
      <app-search-filter class="show-for-m"></app-search-filter>
    </div>
    <div class="flex-container align-spaced align-bottom margin-b-1">
      <div>
        <h1>{{ "highlights.highlight-collections" | i18next }}</h1>
      </div>
      <div>
        <small
          >{{ this.highlightCollections.length }}
          {{ "highlights.collections" | i18next }}</small
        >
      </div>
    </div>
    <app-collections-filter class="show-for-m"></app-collections-filter>
  </div>

  <div class="collections-list grid grid-gap-big">
    <ng-container *ngFor="let collection of this.highlightCollections">
      <div
        class="collection item xs-12 m-6"
        [routerLink]="['/collections/collection-detail', collection.id]"
      >
        <img src="{{ collection.imgUrl | image }}" loading="lazy" />
        <h3 class="title">{{ collection.name }}</h3>
      </div>
    </ng-container>
  </div>
</div>
